import { allFilters } from './../components/bounties/bounties-filters/bounties-filters.component';
import { BountyService } from './../services/bounty.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Tabs } from '../components/bounties/bounties-list/bounties-list.component';
import { WindowService } from '../services/window.service';

export const sortableFields = [
  { label: 'Date (Newest)', value: 'id,desc' },
  { label: 'Date (Oldest)', value: 'id,asc' },
  { label: 'Ending Soonest', value: 'ends_at,asc' },
  { label: 'Reward (Highest)', value: 'reward,desc' },
  { label: 'Reward (Lowest)', value: 'reward,asc' },
  { label: 'Popular (Most)', value: 'likes,desc' },
  { label: 'Popular (Least)', value: 'likes,asc' },
];

@Injectable()
export class BountiesResolver implements Resolve<{}> {
  constructor(
    private bountyService: BountyService,
    private windowService: WindowService,
  ) { }

  async resolve(
    state: ActivatedRouteSnapshot,
  ): Promise<Observable<any> | Promise<any> | any> {
    const { tab, sort, filters, search } = state.queryParams;
    const allTabs = <Tabs[]>['active', 'completed', 'liked'];
    const appliedTab = allTabs.includes(tab) ? tab : allTabs[0];
    const appliedSort = sortableFields.map(f => f.value).includes(sort)
      ? sort
      : sortableFields[0].value;
    const appliedFilters = filters
      ? filters.split(',').filter(val => allFilters.includes(val))
      : [];
    const appData = await this.getAppData({
      appliedFilters,
      appliedTab,
      appliedSort,
      search,
    });

    return {
      listResults: appData,
      appliedFilters,
      appliedSort,
      appliedTab,
      search,
    };
  }

  private async getAppData({
    appliedFilters,
    appliedSort,
    appliedTab,
    search,
  }) {

    const preRenderedData = this.windowService.appData;
    if (preRenderedData) {
      // On first page load, return global data
      return preRenderedData;
    }

    return await this.bountyService.list({
      filters: appliedFilters,
      sort: appliedSort,
      tab: appliedTab,
      search,
      page: 1,
    });
  }
}
